module.exports = __webpack_public_path__ + "static/img/Bachelor_010299.27f5327.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010299.jpg
// module id = 143
// module chunks = 0